import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { HeaderAutoSuggestStyle, HomeAutoSuggestStyle } from './styles';
import { Autocomplete, VisuallyHidden } from '@olxbr/ds-web';
import Search from '@olxbr/olx-icons/dist/System/Search';
import OraculoHistoryItem from '../components/OraculoHistoryItem';
import OraculoCategoryItem from '../components/OraculoCategoryItem';
import { hasCategory, getCategorySuggestions } from '../utils/categorySuggestions';
import { SearchHistoryModule } from '../utils/searchHistory';
import { sendTracking, getLurkerObjectNameByStyle, formatSubmitTrackingPayload, formatCategorySuggestionTrackingPayload, formatHistorySuggestionTrackingPayload } from '../utils/events';
import { getFriendlyUrl } from '../utils/suggestionUrlFormatter';
/**
 * TODO: migrar CSS para styled-components
 * TODO: isolar métodos de negócio em outra camada (em andamento)
 */

var Oraculo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Oraculo, _React$Component);

  function Oraculo(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "searchHistoryModule", _this.getSearchHistoryModule());

    _defineProperty(_assertThisInitialized(_this), "onSuggestionCategorySelected", function (event, _ref) {
      var suggestion = _ref.suggestion,
          suggestionIndex = _ref.suggestionIndex,
          submitMethod = _ref.submitMethod;
      var _this$state = _this.state,
          categorySuggestions = _this$state.categorySuggestions,
          historySuggestions = _this$state.historySuggestions,
          lurkerObjectName = _this$state.lurkerObjectName,
          inputRef = _this$state.inputRef;
      var typedQuery = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '';

      _this.searchHistoryModule.addHistoryItem(suggestion.query);

      sendTracking(formatCategorySuggestionTrackingPayload({
        typedQuery: typedQuery,
        suggestion: suggestion,
        lurkerObjectName: lurkerObjectName,
        submitMethod: submitMethod,
        applicationAppliedCategory: _this.getApplicationAppliedCategory(),
        suggestionIndex: suggestionIndex,
        categorySuggestions: categorySuggestions,
        historySize: historySuggestions.length
      }));

      if (inputRef) {
        inputRef.value = suggestion.query;
      }

      _this.hideSuggestions();

      var onSubmit = _this.props.onSubmit;
      event.preventDefault();

      if (onSubmit) {
        onSubmit(event, suggestion.query, suggestion.category_id);
      } else {
        var url = getFriendlyUrl(suggestion.query, suggestion.category_id);
        window.location.assign(url);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHistorySuggestionSelected", function (event, _ref2) {
      var suggestion = _ref2.suggestion,
          suggestionIndex = _ref2.suggestionIndex,
          submitMethod = _ref2.submitMethod;
      var _this$state2 = _this.state,
          historySuggestions = _this$state2.historySuggestions,
          lurkerObjectName = _this$state2.lurkerObjectName,
          inputRef = _this$state2.inputRef;
      var typedQuery = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '';

      _this.searchHistoryModule.addHistoryItem(suggestion);

      sendTracking(formatHistorySuggestionTrackingPayload({
        typedQuery: typedQuery,
        suggestion: suggestion,
        lurkerObjectName: lurkerObjectName,
        submitMethod: submitMethod,
        applicationAppliedCategory: _this.getApplicationAppliedCategory(),
        suggestionIndex: suggestionIndex,
        historySuggestions: historySuggestions
      }));

      if (inputRef) {
        inputRef.value = suggestion;
      }

      _this.hideSuggestions();

      var onSubmit = _this.props.onSubmit;
      event.preventDefault();

      if (onSubmit) {
        onSubmit(event, suggestion, _this.getApplicationAppliedCategory());
      } else {
        var url = getFriendlyUrl(suggestion, _this.getApplicationAppliedCategory());
        window.location.assign(url);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsFetchRequested", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var value, _this$props, categoryMaxSuggestions, url, testId, categoryIdFilter, response, historySuggestions, categorySuggestions;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = _ref3.value;
                _this$props = _this.props, categoryMaxSuggestions = _this$props.categoryMaxSuggestions, url = _this$props.url, testId = _this$props.testId, categoryIdFilter = _this$props.categoryIdFilter;
                _context.next = 4;
                return getCategorySuggestions(url, value, _this.state.currentCategoryId, testId, categoryIdFilter);

              case 4:
                response = _context.sent;
                historySuggestions = _this.searchHistoryModule.getHistorySuggestions(value);

                if (response.suggestions && response.suggestions !== _this.state.categorySuggestions) {
                  categorySuggestions = response.suggestions.slice(0, categoryMaxSuggestions);

                  _this.setState({
                    lastValidQuery: value,
                    categorySuggestions: categorySuggestions,
                    historySuggestions: historySuggestions
                  });
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function () {
      _this.setState({
        categorySuggestions: [],
        historySuggestions: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestion", function (suggestion, query, index) {
      var homeStyle = _this.props.inputStyle === 'home';
      var categoryIdFilter = _this.props.categoryIdFilter;
      var lurkerObjectName = _this.state.lurkerObjectName;
      var boldSugg = suggestion.query.trim().slice(query.trim().length);
      return hasCategory(suggestion) ? /*#__PURE__*/React.createElement(OraculoCategoryItem, {
        key: index,
        query: query,
        boldSugg: boldSugg,
        suggestion: suggestion,
        homeStyle: homeStyle,
        indexPosition: index,
        categoryIdFilter: categoryIdFilter,
        onClick: _this.onSuggestionCategorySelected
      }) : /*#__PURE__*/React.createElement(OraculoHistoryItem, {
        key: index,
        query: query,
        boldSugg: boldSugg,
        suggestion: suggestion,
        homeStyle: homeStyle,
        indexPosition: index,
        onClick: _this.onHistorySuggestionSelected,
        deleteHistoryItem: function deleteHistoryItem(e) {
          _this.searchHistoryModule.deleteHistoryItem(e, suggestion.query, query, lurkerObjectName);

          _this.setState({
            historySuggestions: _this.searchHistoryModule.historySuggestions
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();

        _this.handleSubmit(event, 'enter');
      }
    });

    var _this$props2 = _this.props,
        defaultValue = _this$props2.defaultValue,
        inputStyle = _this$props2.inputStyle,
        _lurkerObjectName = _this$props2.lurkerObjectName;
    var currentQuery = defaultValue || '';
    _this.state = {
      lastValidQuery: currentQuery,
      currentCategoryId: _this.props.currentCategoryId,
      categorySuggestions: [],
      historySuggestions: [],
      lurkerObjectName: _lurkerObjectName || getLurkerObjectNameByStyle(inputStyle),
      inputRef: null
    };
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.wrapperRef = React.createRef();
    return _this;
  }

  var _proto = Oraculo.prototype;

  // History suggestions
  _proto.getSearchHistoryModule = function getSearchHistoryModule() {
    var _this$props3 = this.props,
        lurkerId = _this$props3.lurkerId,
        historyMaxWords = _this$props3.historyMaxWords,
        historyMaxSuggestions = _this$props3.historyMaxSuggestions,
        initialHistoryMaxSuggestions = _this$props3.initialHistoryMaxSuggestions,
        categoryIdFilter = _this$props3.categoryIdFilter,
        historyKey = _this$props3.historyKey;
    if (typeof window === 'undefined') return;
    var hideSuggestions = categoryIdFilter != null;
    return new SearchHistoryModule({
      lurkerId: lurkerId,
      historyMaxWords: historyMaxWords,
      historyMaxSuggestions: historyMaxSuggestions,
      initialHistoryMaxSuggestions: initialHistoryMaxSuggestions,
      hideSuggestions: hideSuggestions,
      historyKey: historyKey
    });
  };

  _proto.setSearchHistoryModule = function setSearchHistoryModule() {
    this.searchHistoryModule = this.getSearchHistoryModule();
  };

  // General
  _proto.getApplicationAppliedCategory = function getApplicationAppliedCategory() {
    return this.props.currentCategoryId || '';
  };

  _proto.handleInputChange = function handleInputChange(query) {
    if (!query && !this.props.suggestionsDisabled) {
      this.onSuggestionsFetchRequested({
        value: ''
      });
    }

    var onChange = this.props.onChange;

    if (onChange) {
      var value = query;
      onChange({
        target: {
          value: value
        }
      });
    }

    if (!this.props.suggestionsDisabled) {
      this.onSuggestionsFetchRequested({
        value: query
      });
    }
  };

  _proto.handleSubmit = function handleSubmit(event, submitMethod) {
    event.persist();
    var _this$state3 = this.state,
        lurkerObjectName = _this$state3.lurkerObjectName,
        categorySuggestions = _this$state3.categorySuggestions,
        historySuggestions = _this$state3.historySuggestions,
        inputRef = _this$state3.inputRef;
    var typedQuery = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '';
    this.searchHistoryModule.addHistoryItem(typedQuery);
    sendTracking(formatSubmitTrackingPayload({
      query: typedQuery,
      lurkerObjectName: lurkerObjectName,
      submitMethod: submitMethod,
      applicationAppliedCategory: this.getApplicationAppliedCategory(),
      categorySuggestions: categorySuggestions,
      historySuggestions: historySuggestions
    }));
    var onSubmit = this.props.onSubmit;

    if (onSubmit) {
      onSubmit(event, typedQuery, this.getApplicationAppliedCategory());
    } else {
      event.preventDefault();
      var url = getFriendlyUrl(typedQuery, this.getApplicationAppliedCategory());
      window.location.assign(url);
    }

    this.hideSuggestions();
  };

  _proto.renderInputStyle = function renderInputStyle() {
    switch (this.props.inputStyle) {
      case 'home':
        return /*#__PURE__*/React.createElement(HomeAutoSuggestStyle, {
          id: "home-autosuggest"
        });

      case 'header':
        return /*#__PURE__*/React.createElement(HeaderAutoSuggestStyle, {
          id: "listing-autosuggest",
          rounded: this.props.rounded,
          submitButtonColor: this.props.submitButtonColor,
          suggestBoxWidth: this.props.suggestBoxWidth,
          hasIconLeft: !!this.props.iconLeft,
          submitIconHidden: this.props.hideSubmitButton,
          darkBorderHover: this.props.darkBorderHover
        });
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$wrapperRef, _this$wrapperRef$curr;

    this.setSearchHistoryModule();
    var inputRef = (_this$wrapperRef = this.wrapperRef) === null || _this$wrapperRef === void 0 ? void 0 : (_this$wrapperRef$curr = _this$wrapperRef.current) === null || _this$wrapperRef$curr === void 0 ? void 0 : _this$wrapperRef$curr.querySelector('input');
    this.setState({
      inputRef: inputRef
    });
    var _this$props4 = this.props,
        defaultValue = _this$props4.defaultValue,
        suggestionsDisabled = _this$props4.suggestionsDisabled;

    if (!suggestionsDisabled) {
      this.handleInputChange(defaultValue);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.lurkerId !== prevProps.lurkerId || this.props.categoryIdFilter !== prevProps.categoryIdFilter) {
      this.setSearchHistoryModule();
    }

    if (this.props.categoryIdFilter !== prevProps.categoryIdFilter) {
      this.hideSuggestions();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state4 = this.state,
        historySuggestions = _this$state4.historySuggestions,
        categorySuggestions = _this$state4.categorySuggestions,
        lastValidQuery = _this$state4.lastValidQuery;
    var suggestions = [].concat(historySuggestions, categorySuggestions);
    var optionsList = suggestions.map(function (suggestion, index) {
      return _this2.renderSuggestion(suggestion, lastValidQuery, index);
    });
    var _this$props5 = this.props,
        placeholder = _this$props5.placeholder,
        query = _this$props5.query,
        hideSubmitButton = _this$props5.hideSubmitButton,
        debounceTime = _this$props5.debounceTime,
        iconLeft = _this$props5.iconLeft,
        suggestionsDisabled = _this$props5.suggestionsDisabled,
        defaultValue = _this$props5.defaultValue;
    var inputStyle = {
      fontFamily: 'var(--font-family)'
    };
    hideSubmitButton && Object.assign(inputStyle, {
      marginRight: 0
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "search-wrap-box",
      ref: this.wrapperRef
    }, this.renderInputStyle(), iconLeft && /*#__PURE__*/React.createElement("div", {
      className: "left-icon"
    }, iconLeft), /*#__PURE__*/React.createElement(Autocomplete, {
      id: "searchtext",
      style: inputStyle,
      placeholder: placeholder,
      debounceTime: debounceTime,
      spellCheck: false,
      value: query,
      defaultValue: defaultValue,
      onKeyPress: this.handleKeyPress,
      onChange: this.handleInputChange
    }, !suggestionsDisabled && optionsList), !hideSubmitButton && /*#__PURE__*/React.createElement("button", {
      className: "search-button-submit",
      onClick: function onClick(e) {
        return _this2.handleSubmit(e, 'search_button_click');
      }
    }, /*#__PURE__*/React.createElement(Search, {
      size: 24
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, "Buscar")));
  };

  return Oraculo;
}(React.Component);

Oraculo.propTypes = process.env.NODE_ENV !== "production" ? {
  query: PropTypes.string,
  defaultValue: PropTypes.string,
  url: PropTypes.string,
  currentCategoryId: PropTypes.any,
  onChange: PropTypes.func,
  testId: PropTypes.string,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  lurkerId: PropTypes.string,
  historyKey: PropTypes.string,
  categoryIdFilter: PropTypes.string,
  historyMaxWords: PropTypes.number,
  historyMaxSuggestions: PropTypes.number,
  categoryMaxSuggestions: PropTypes.number,
  initialHistoryMaxSuggestions: PropTypes.number,
  debounceTime: PropTypes.number,
  lurkerObjectName: PropTypes.string,
  suggestionsDisabled: PropTypes.bool,
  // Style props
  inputStyle: PropTypes.oneOf(['home', 'header']),
  rounded: PropTypes.bool,
  submitButtonColor: PropTypes.oneOf(['transparent', 'orange']),
  darkBorderHover: PropTypes.bool,
  iconLeft: PropTypes.any,
  hideSubmitButton: PropTypes.bool,
  suggestBoxWidth: PropTypes.number
} : {};
Oraculo.defaultProps = {
  defaultValue: '',
  placeholder: 'Buscar',
  url: 'https://oraculo.olx.com.br/',
  lurkerId: 'common-user',
  historyKey: 'search-history',
  historyMaxWords: 100,
  historyMaxSuggestions: 3,
  categoryMaxSuggestions: 5,
  initialHistoryMaxSuggestions: 8,
  inputStyle: 'header',
  rounded: false,
  submitButtonColor: 'transparent',
  debounceTime: 100,
  darkBorderHover: false,
  suggestionsDisabled: false
};
export default Oraculo;